import styled from 'styled-components';
import { overlineLabel } from '@/styles/mixins';

export const Dl = styled.dl<{ $maxWidth?: string }>`
  display: grid;
  grid-template-columns: minmax(160px, max-content) 1fr;
  column-gap: ${({ theme }) => theme.spacing[4]};
  row-gap: ${({ theme }) => theme.spacing[2]};
  margin: 0 0 ${({ theme }) => theme.spacing[5]};
  max-width: ${({ $maxWidth }) => $maxWidth ?? '600px'};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.normal};

  @media (max-width: 575.98px) {
    grid-template-columns: 1fr;
    row-gap: ${({ theme }) => theme.spacing[1]};
  }
`;

export const Dt = styled.dt`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0;

  @media (max-width: 575.98px) {
    ${overlineLabel}
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

export const Dd = styled.dd`
  margin: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-word;

  @media (max-width: 575.98px) {
    margin-bottom: ${({ theme }) => theme.spacing[2]};
  }
`;
